import { inject, Injectable } from "@angular/core";
import { UserPreferences, UserPreferencesService } from "../auth-o3/shared/services/user-preferences.service";
import { FeatureFlag, FeatureKeys } from "../feature-flag/feature-flag.model";
import { FeatureFlagService } from "../feature-flag/feature-flag.service";

export type AppSettings = {
    userPreferences?: UserPreferences;
    featureFlags?: FeatureFlag[];
}

@Injectable()
export class AppSettingsService {

    private readonly userPreferencesService = inject(UserPreferencesService);
    private readonly featureFlagService = inject(FeatureFlagService);

    public async initialize(): Promise<void> {
        try {
            const userPreferences = (await this.userPreferencesService.getPreferences().toPromise()) || {};
            const featureFlags = (await this.featureFlagService.getFeatureFlags().toPromise()) || [];

            GlobalSettings.setAppSettings({
                userPreferences,
                featureFlags
            });
        } catch (err) {
            // Silently fail
            GlobalSettings.setAppSettings({ 
                userPreferences: {},
                featureFlags: []
            });
        }
    }

}

export class GlobalSettings {

    private static appSettings: AppSettings = { };

    public static setAppSettings(settings: Partial<AppSettings>): void {
        this.appSettings = {
            ...this.appSettings,
            ...settings
        };
    }

    public static getAppSettings(): AppSettings {
        if (!this.appSettings) {
            throw new Error("App settings have not been initialized.");
        }
        return this.appSettings;
    }

    static getFeatureFlag(key: FeatureKeys): FeatureFlag | undefined {
        return this.appSettings.featureFlags?.find(flag => flag.featureName === key);
    }
}